import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import {
  defaultBody,
  defaultBottoms,
  defaultFace,
  defaultHairstyle,
  defaultShoes,
  defaultStageBody,
  defaultStageBottoms,
  defaultStageFace,
  defaultStageHairstyle,
  defaultStageShoes,
  defaultStageTops,
  defaultTops,
} from "src/const/initAvatar";
import { initialAvatarState } from "src/reducks/AvatarStore/initializes";
import type { AvatarItem } from "src/reducks/AvatarStore/types";

export const avatarSlice = createSlice({
  initialState: initialAvatarState,
  name: "avatar",
  reducers: {
    addAvatar: (state, action: PayloadAction<AvatarItem>) => {
      // 特殊なアイテムがあるかないかを判断
      const checkedOtherItems = state.selectedItems.filter((item) => {
        return item.category === "OTHER";
      });

      // 選択済みのアイテムを選択したかしていないかを判断
      const checkedDuplicationItems = state.selectedItems.filter((item) => {
        return item.id === action.payload.id;
      });

      // 特殊なアバターを着たら着る前の状態を保存
      if (
        checkedDuplicationItems.length === 0 &&
        checkedOtherItems.length === 0
      ) {
        state.prevSelectedItems = state.selectedItems;
        state.prevSelectedStageItems = state.selectedStageItems;
      }

      // 特殊なアバターから通常のアイテムに着替えるとき特殊なアバターに着替える前の状態に戻す。
      if (
        action.payload.category !== "BODY" &&
        action.payload.category !== "FACE" &&
        action.payload.category !== "OTHER" &&
        checkedOtherItems.length !== 0
      ) {
        // itemlist
        const prevAvatarItem = state.prevSelectedItems.filter((item) => {
          return item.category !== "OTHER";
        });
        state.selectedItems = prevAvatarItem;

        // stageitemlist
        const prevStageItem = state.prevSelectedStageItems.filter((item) => {
          return item.category !== "OTHER";
        });
        state.selectedStageItems = prevStageItem;
      }

      // 特殊なアバターが追加されたら下記のカテゴリーのアイテムを消す。
      if (action.payload.category === "OTHER") {
        if (checkedDuplicationItems.length === 0) {
          ///////// アバターアイテムの処理 //////////////////////////////////////////////////////////////////

          const otherRiversItems = state.selectedItems.filter((item) => {
            return (
              item.category !== "HEAD" &&
              item.category !== "HAIR" &&
              item.category !== "FACE_PARTS" &&
              item.category !== "TOPS" &&
              item.category !== "BOTTOMS" &&
              item.category !== "SHOES" &&
              item.category !== "BACK" &&
              item.category !== "HAND" &&
              item.category !== "OTHER" &&
              item.id !== action.payload.id
            );
          });
          otherRiversItems.push(action.payload);
          state.selectedItems = otherRiversItems;

          ///////// プレビューで使用するアバターアイテムの処理 //////////////////////////////////////////////////////////////////
          const otherRiversStageItems = state.selectedStageItems.filter(
            (item) => {
              return (
                item.category !== "HEAD" &&
                item.category !== "HAIR" &&
                item.category !== "FACE_PARTS" &&
                item.category !== "TOPS" &&
                item.category !== "BOTTOMS" &&
                item.category !== "SHOES" &&
                item.category !== "BACK" &&
                item.category !== "HAND" &&
                item.category !== "OTHER"
              );
            },
          );

          // 選択したアイテムを追加
          action.payload.parts.map((item) => {
            otherRiversStageItems.push(item);
          });
          // 数字が小さいレイヤーから大きくレイヤーへ整理
          otherRiversStageItems.sort((a, b) => {
            return a.layer - b.layer;
          });
          state.selectedStageItems = otherRiversStageItems;
        } else {
          // itemlist
          const prevAvatarItem = state.prevSelectedItems.filter((item) => {
            return item.category !== "OTHER";
          });
          state.selectedItems = prevAvatarItem;

          // stageitemlist
          const prevStageItem = state.prevSelectedStageItems.filter((item) => {
            return item.category !== "OTHER";
          });
          state.selectedStageItems = prevStageItem;
        }
      } else if (
        action.payload.category === "BODY" ||
        action.payload.category === "FACE"
      ) {
        ///////// 顔と素体の時 ////////////
        ///////// アバターアイテムの処理 ////////////

        // 追加したアイテムと同じカテゴリーのアイテムを消す。
        const RiversItems = state.selectedItems.filter((item) => {
          return (
            item.category !== action.payload.category &&
            item.id !== action.payload.id
          );
        });

        if (checkedDuplicationItems.length === 0) {
          RiversItems.push(action.payload);
          state.selectedItems = RiversItems;
        } else {
          state.selectedItems = RiversItems;
        }

        const checkedBody = state.selectedItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedInitBody = state.initSelectedItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedFace = state.selectedItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedInitFace = state.initSelectedItems.filter((item) => {
          return item.category === "BODY";
        });

        // アイテムがない場合
        if (checkedBody.length === 0) {
          if (checkedInitBody.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultBody);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitBody[0]);
          }
        }

        // アイテムがない場合
        if (checkedFace.length === 0) {
          if (checkedInitFace.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultFace);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitFace[0]);
          }
        }

        //////////// プレビューで使用するアバターアイテムの処理 ////////////
        // 追加したアイテムと同じカテゴリーのアイテムを消す。
        const RiversStageItems = state.selectedStageItems.filter((item) => {
          return item.category !== action.payload.category;
        });

        if (checkedDuplicationItems.length === 0) {
          // 選択したアイテムを追加
          action.payload.parts?.map((item) => {
            RiversStageItems.push(item);
          });
          // 数字が小さいレイヤーから大きくレイヤーへ整理
          RiversStageItems.sort((a, b) => {
            return a.layer - b.layer;
          });
          state.selectedStageItems = RiversStageItems;
        } else {
          state.selectedStageItems = RiversStageItems;
          state.selectedStageItems = RiversStageItems;
          // 数字が小さいレイヤーから大きくレイヤーへ整理
          RiversStageItems.sort((a, b) => {
            return a.layer - b.layer;
          });
        }

        const checkedStageBody = state.selectedStageItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedInitStageBody = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "BODY";
          },
        );
        const checkedStageFace = state.selectedStageItems.filter((item) => {
          return item.category === "FACE";
        });
        const checkedInitStageFace = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "FACE";
          },
        );

        // アイテムがない場合
        if (checkedStageBody.length === 0) {
          if (checkedInitStageBody.length === 0) {
            // 初期アバターにもない場合
            defaultStageBody.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageBody.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }

        // アイテムがない場合
        if (checkedStageFace.length === 0) {
          if (checkedInitStageFace.length === 0) {
            // 初期アバターにもない場合
            defaultStageFace.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageFace.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }

        RiversStageItems.sort((a, b) => {
          return a.layer - b.layer;
        });
      } else {
        //////////// アバターアイテムの処理 ////////////

        // 追加したアイテムと同じカテゴリーのアイテムを消す。
        const RiversItems = state.selectedItems.filter((item) => {
          return (
            item.category !== action.payload.category &&
            item.id !== action.payload.id
          );
        });

        if (checkedDuplicationItems.length === 0) {
          RiversItems.push(action.payload);
          state.selectedItems = RiversItems;
        } else {
          state.selectedItems = RiversItems;
        }

        /////////////////////////////////////////////////最低限必要なアバターを着ていないときの処理

        const checkedHairstyle = state.selectedItems.filter((item) => {
          return item.category === "HAIR";
        });
        const checkedInitHairstyle = state.initSelectedItems.filter((item) => {
          return item.category === "HAIR";
        });
        const checkedBody = state.selectedItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedInitBody = state.initSelectedItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedFace = state.selectedItems.filter((item) => {
          return item.category === "FACE";
        });
        const checkedInitFace = state.initSelectedItems.filter((item) => {
          return item.category === "FACE";
        });
        const checkedTops = state.selectedItems.filter((item) => {
          return item.category === "TOPS";
        });
        const checkedInitTops = state.initSelectedItems.filter((item) => {
          return item.category === "TOPS";
        });
        const checkedBottoms = state.selectedItems.filter((item) => {
          return item.category === "BOTTOMS";
        });
        const checkedInitBottoms = state.initSelectedItems.filter((item) => {
          return item.category === "BOTTOMS";
        });
        const checkedShoes = state.selectedItems.filter((item) => {
          return item.category === "SHOES";
        });
        const checkedInitShoes = state.initSelectedItems.filter((item) => {
          return item.category === "SHOES";
        });

        // アイテムがない場合
        if (checkedHairstyle.length === 0) {
          if (checkedInitHairstyle.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultHairstyle);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitHairstyle[0]);
          }
        }

        // アイテムがない場合
        if (checkedBody.length === 0) {
          if (checkedInitBody.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultBody);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitBody[0]);
          }
        }

        // アイテムがない場合
        if (checkedFace.length === 0) {
          if (checkedInitFace.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultFace);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitFace[0]);
          }
        }

        // アイテムがない場合
        if (checkedTops.length === 0) {
          if (checkedInitTops.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultTops);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitTops[0]);
          }
        }
        // アイテムがない場合
        if (checkedBottoms.length === 0) {
          if (checkedInitBottoms.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultBottoms);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitBottoms[0]);
          }
        }
        // アイテムがない場合
        if (checkedShoes.length === 0) {
          if (checkedInitShoes.length === 0) {
            // 初期アバターにもない場合
            state.selectedItems.push(defaultShoes);
          } else {
            // 初期アバターがある
            state.selectedItems.push(checkedInitShoes[0]);
          }
        }

        //////////// プレビューで使用するアバターアイテムの処理 ////////////
        // 追加したアイテムと同じカテゴリーのアイテムを消す。
        const RiversStageItems = state.selectedStageItems.filter((item) => {
          return item.category !== action.payload.category;
        });

        if (checkedDuplicationItems.length === 0) {
          // 選択したアイテムを追加
          action.payload.parts?.map((item) => {
            RiversStageItems.push(item);
          });
          // 数字が小さいレイヤーから大きくレイヤーへ整理
          RiversStageItems.sort((a, b) => {
            return a.layer - b.layer;
          });
          state.selectedStageItems = RiversStageItems;
        } else {
          state.selectedStageItems = RiversStageItems;
          state.selectedStageItems = RiversStageItems;
          // 数字が小さいレイヤーから大きくレイヤーへ整理
          RiversStageItems.sort((a, b) => {
            return a.layer - b.layer;
          });
        }

        /////////////////////////////////////////////////最低限必要なアバターを着ていないときの処理
        const checkedStageHairstyle = state.selectedStageItems.filter(
          (item) => {
            return item.category === "HAIR";
          },
        );
        const checkedInitStageHairstyle = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "HAIR";
          },
        );
        const checkedStageBody = state.selectedStageItems.filter((item) => {
          return item.category === "BODY";
        });
        const checkedInitStageBody = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "BODY";
          },
        );
        const checkedStageFace = state.selectedStageItems.filter((item) => {
          return item.category === "FACE";
        });
        const checkedInitStageFace = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "FACE";
          },
        );
        const checkedStageTops = state.selectedStageItems.filter((item) => {
          return item.category === "TOPS";
        });
        const checkedInitStageTops = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "TOPS";
          },
        );
        const checkedStageBottoms = state.selectedStageItems.filter((item) => {
          return item.category === "BOTTOMS";
        });
        const checkedInitStageBottoms = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "BOTTOMS";
          },
        );
        const checkedStageShoes = state.selectedStageItems.filter((item) => {
          return item.category === "SHOES";
        });
        const checkedInitStageShoes = state.initSelectedStageItems.filter(
          (item) => {
            return item.category === "SHOES";
          },
        );

        // アイテムがない場合
        if (checkedStageHairstyle.length === 0) {
          if (checkedInitStageHairstyle.length === 0) {
            // 初期アバターにもない場合
            defaultStageHairstyle.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageHairstyle.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }

        // アイテムがない場合
        if (checkedStageBody.length === 0) {
          if (checkedInitStageBody.length === 0) {
            // 初期アバターにもない場合
            defaultStageBody.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageBody.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }

        // アイテムがない場合
        if (checkedStageFace.length === 0) {
          if (checkedInitStageFace.length === 0) {
            // 初期アバターにもない場合
            defaultStageFace.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageFace.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }

        // アイテムがない場合
        if (checkedStageTops.length === 0) {
          if (checkedInitStageTops.length === 0) {
            // 初期アバターにもない場合
            defaultStageTops.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageTops.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }
        // アイテムがない場合
        if (checkedStageBottoms.length === 0) {
          if (checkedInitStageBottoms.length === 0) {
            // 初期アバターにもない場合
            defaultStageBottoms.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageBottoms.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }
        // アイテムがない場合
        if (checkedStageShoes.length === 0) {
          if (checkedInitStageShoes.length === 0) {
            // 初期アバターにもない場合
            defaultStageShoes.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          } else {
            // 初期アバターがある
            checkedInitStageShoes.map((defaultItem) => {
              state.selectedStageItems.push(defaultItem);
            });
          }
        }

        // 数字が小さいレイヤーから大きくレイヤーへ整理
        RiversStageItems.sort((a, b) => {
          return a.layer - b.layer;
        });
      }

      const totalPoint = state.selectedItems
        .filter((item) => {
          return !item.bought;
        })
        .reduce((acc, item) => {
          return acc + item.point;
        }, 0);
      state.selectedPoints = totalPoint;
    },
    initSetAvatar: (state, action: PayloadAction<AvatarItem>) => {
      const checkedOtherItems = state.selectedItems.filter((item) => {
        return item.category === "OTHER";
      });

      const checkedDuplicationItems = state.selectedItems.filter((item) => {
        return item.id === action.payload.id;
      });

      // 特殊なアバターを着たら着る前の状態を保存
      if (
        checkedDuplicationItems.length === 0 &&
        checkedOtherItems.length === 0
      ) {
        state.prevSelectedItems = state.selectedItems;
        state.prevSelectedStageItems = state.selectedStageItems;
      }

      // 特殊なアバターから通常のアイテムに着替えるとき特殊なアバターに着替える前の状態に戻す。
      if (
        action.payload.category !== "FACE" &&
        action.payload.category !== "BODY" &&
        action.payload.category !== "OTHER" &&
        checkedOtherItems.length !== 0
      ) {
        // itemlist
        const prevAvatarItem = state.prevSelectedItems.filter((item) => {
          return item.category !== "OTHER";
        });
        state.initSelectedItems = prevAvatarItem;

        // stageitemlist
        const prevStageItem = state.prevSelectedStageItems.filter((item) => {
          return item.category !== "OTHER";
        });
        state.initSelectedStageItems = prevStageItem;
      }

      // 特殊なアバターが追加されたら下記のカテゴリーのアイテムを消す。
      if (action.payload.category === "OTHER") {
        ///////// アバターアイテムの処理 //////////////////////////////////////////////////////////////////

        const otherRiversItems = state.selectedItems.filter((item) => {
          return (
            item.category !== "HEAD" &&
            item.category !== "HAIR" &&
            item.category !== "FACE_PARTS" &&
            item.category !== "TOPS" &&
            item.category !== "BOTTOMS" &&
            item.category !== "SHOES" &&
            item.category !== "BACK" &&
            item.category !== "HAND" &&
            item.category !== "OTHER" &&
            item.id !== action.payload.id
          );
        });
        otherRiversItems.push(action.payload);
        state.initSelectedItems = otherRiversItems;

        ///////// プレビューで使用するアバターアイテムの処理 //////////////////////////////////////////////////////////////////
        const otherRiversStageItems = state.selectedStageItems.filter(
          (item) => {
            return (
              item.category !== "HEAD" &&
              item.category !== "HAIR" &&
              item.category !== "FACE_PARTS" &&
              item.category !== "TOPS" &&
              item.category !== "BOTTOMS" &&
              item.category !== "SHOES" &&
              item.category !== "BACK" &&
              item.category !== "HAND" &&
              item.category !== "OTHER"
            );
          },
        );

        // 選択したアイテムを追加
        action.payload.parts.map((item) => {
          otherRiversStageItems.push(item);
        });
        // 数字が小さいレイヤーから大きくレイヤーへ整理
        otherRiversStageItems.sort((a, b) => {
          return a.layer - b.layer;
        });
        state.initSelectedStageItems = otherRiversStageItems;
      } else {
        ///////// アバターアイテムの処理 //////////////////////////////////////////////////////////////////

        // 追加したアイテムと同じカテゴリーのアイテムを消す。
        const RiversItems = state.selectedItems.filter((item) => {
          return (
            item.category !== action.payload.category &&
            item.id !== action.payload.id
          );
        });
        RiversItems.push(action.payload);
        state.initSelectedItems = RiversItems;

        ///////// プレビューで使用するアバターアイテムの処理 //////////////////////////////////////////////////////////////////
        // 追加したアイテムと同じカテゴリーのアイテムを消す。
        const RiversStageItems = state.selectedStageItems.filter((item) => {
          return item.category !== action.payload.category;
        });
        // 選択したアイテムを追加
        action.payload.parts?.map((item) => {
          RiversStageItems.push(item);
        });
        // 数字が小さいレイヤーから大きくレイヤーへ整理
        RiversStageItems.sort((a, b) => {
          return a.layer - b.layer;
        });
        state.initSelectedStageItems = RiversStageItems;
      }
    },
    // 指定のカテゴリーアイテムを選択したアイテムからなくす。
    removeAvatarByCategory: (
      state,
      action: PayloadAction<{ category: string }>,
    ) => {
      // 同じカテゴリーのアイテムを消す。
      const RiversItems = state.selectedItems.filter((item) => {
        return item.category !== action.payload.category;
      });
      state.selectedItems = RiversItems;

      // 同じカテゴリープレビュー用アイテムを消す。
      const RiversStageItems = state.selectedStageItems.filter((item) => {
        return item.category !== action.payload.category;
      });
      RiversStageItems.sort((a, b) => {
        return a.layer - b.layer;
      });
      state.selectedStageItems = RiversStageItems;
    },
    resetAvatar: (state) => {
      state.initSelectedItems.length = 0;
      state.initSelectedStageItems.length = 0;
      state.selectedItems.length = 0;
      state.selectedStageItems.length = 0;
    },
  },
});

export const { addAvatar, initSetAvatar, removeAvatarByCategory, resetAvatar } =
  avatarSlice.actions;

export const avatarReducer = avatarSlice.reducer;
